import { lazy, Suspense } from "react";
import { createBrowserRouter, Outlet } from "react-router-dom";

import RouteFallback from "@/components/ui/RouteFallback";
import { PortfolioEntryRedirect } from "@/features/product/routes/PortfolioEntryRedirect";
import { PlatformTokenEntryRedirect } from "@/features/product/routes/PlatformTokenEntryRedirect";
import {
  platformTokenRouteTabs,
  portfolioTabs,
} from "@/features/product/types";
import RouteErrorPage from "@/pages/RouteErrorPage";

const ProductRoutePage = lazy(() => import("@/pages/ProductRoutePage"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));
const ExploreRoute = lazy(
  () => import("@/features/product/routes/ExploreRoute"),
);
const AssetRoute = lazy(() => import("@/features/product/routes/AssetRoute"));
const PortfolioRoute = lazy(
  () => import("@/features/product/routes/PortfolioRoute"),
);
const FundraisingRoute = lazy(
  () => import("@/features/product/routes/FundraisingRoute"),
);
const PlatformRoute = lazy(
  () => import("@/features/product/routes/PlatformRoute"),
);

const productLayout = (
  <Suspense fallback={<RouteFallback />}>
    <ProductRoutePage />
  </Suspense>
);

export const router = createBrowserRouter([
  {
    element: <Outlet />,
    errorElement: <RouteErrorPage />,
    children: [
      {
        element: productLayout,
        children: [
          { index: true, element: <ExploreRoute /> },
          { path: "asset/:tokenAddress", element: <AssetRoute /> },
          {
            path: "portfolio",
            children: [
              { index: true, element: <PortfolioEntryRedirect /> },
              ...portfolioTabs.map((tab) => ({
                path: tab,
                element: <PortfolioRoute tab={tab} />,
              })),
            ],
          },
          { path: "invite", element: <PortfolioEntryRedirect invite /> },
          { path: "fundraising", element: <FundraisingRoute /> },
          {
            path: "platform-token",
            children: [
              { index: true, element: <PlatformTokenEntryRedirect /> },
              ...platformTokenRouteTabs.map((tab) => ({
                path: tab,
                element: <PlatformRoute tab={tab} />,
              })),
            ],
          },
          {
            path: "analytics",
            element: <PlatformTokenEntryRedirect />,
          },
          {
            path: "buyback",
            element: <PlatformTokenEntryRedirect tab="buyback" />,
          },
          { path: "create", element: <ExploreRoute /> },
        ],
      },
      {
        path: "*",
        element: (
          <Suspense fallback={<RouteFallback />}>
            <NotFoundPage />
          </Suspense>
        ),
      },
    ],
  },
]);
